import React  from 'react';
import Modal from "@material-ui/core/Modal/Modal";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import AddExams from "../addExams";
/**
 * Exam selection model.
 * @param props
 * @returns {*}
 */
function ExamSelectionModel(props) {
    const { closeExamModel, addHeaderExamModal } = props;
    return (
        <div>
            <Modal className="password-modal exam-modal exam-selector-modal"
                   aria-labelledby="simple-modal-title"
                   aria-describedby="simple-modal-description"
                   open={addHeaderExamModal}
                   onClose={closeExamModel}>
                <DialogContent>
                    <AddExams closeModal={closeExamModel}/>
                </DialogContent>
            </Modal>
        </div>
    );
}

export default ExamSelectionModel;
